<!--ADDED BY HIMANSHU -->
<div class="menu-top-container">
  <div class="_wf-pp-icondiva1">
    <div class="_wf-pp-imagesdiva1">
      <div class="image_in_container">
        @if (headerJson.logo!=undefined) {
          <img
            [routerLink]="'/'+appService._appData.DEFAULT_APPLICATION+'/dashboard'"
            [attr.src]="headerJson.logo" />
        }
      </div>
      <div class="_wf-pp-removeicona1">
        <div class="_wf-pp-textremoveicona1" (click)="removeSidebar();"><i class="fa fa-times-circle"></i></div>
      </div>
    </div>
  </div>
  @if (showSearchInput) {
    <div class="_wf-pp-paddingforsearch">
      <div class="_wf-pp-searchinputsubdiva1">
        <div title="{{(smartMenuEnabled?'smmnuenabled' :'') | translate | async}} " class="_wf-pp-searchiconforsearcha1 {{smartMenuEnabled?'smart_menu':''}}" >
          <div class="_wf-pp-searchkeya1" (click)="toggleSmartMenu()"><i class="fa fa-search"></i></div>
        </div>
        <div action="/search" class="_wf-pp-searchboxsubnewa1">
          <input #search_menu type="search" class="_wf-pp-searchinputa1 w-input" maxlength="256" name="query"
            [attr.placeholder]="'field.hint.search_menu' | translate | async" id="search" required=""
            >
        </div>
      </div>
    </div>
  }
</div>
<div class="_wf-pp-footera1">
  <div class="_wf-pp-footertext">
    <div class="_wf-pp-footericon"> <img alt="" loading="lazy" src="assets/images/logo-powered-reverse.svg"></div>
    <!-- <div class="_wf-pp-footericon"><img src="assets/images/KX_logo.png" loading="lazy" alt=""></div> -->
  </div>
</div>

<!-- <div class="menu-item search-in-menu ng-star-inserted">
<input class="form-control search-in-menu-input" id="search-menu-text" name="menu-search" placeholder="Search in menu" type="text">
<i class="menu-search-icon fa fa-search"></i>
</div> -->
@if (isArray(searchItemsArray)) {
  <app-sidebar-nav-items class="nav" [items]="searchItemsArray">
  </app-sidebar-nav-items>
}
@if (!isArray(searchItemsArray)) {
  <app-sidebar-nav-items class="nav" [items]="navItemsArray">
  </app-sidebar-nav-items>
}